import { useSiteContent } from '@/hooks/useSiteContent';
import styles from './BookSkiPass.module.css';
import { BookSkiPassForm } from './BookSkiPassForm';

export const BookSkiPass = () => {
  const { content } = useSiteContent();

  return (
    <div className={styles.bookSkiPassContainer}>
      <div className={styles.bookSkiPassContent}>
        <h1 className={styles.bookSkiPassTitle}>{content.heroTitle}</h1>
        <BookSkiPassForm />
      </div>
    </div>
  );
};